import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../lib/authApi";
import { useAuth } from "../auth/AuthProvider";

export default function AccountMenu() {
    const { user, refresh } = useAuth();
    const nav = useNavigate();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function onClickOutside(e) {
            if (!ref.current) return;
            if (!ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", onClickOutside);
        return () => document.removeEventListener("mousedown", onClickOutside);
    }, []);

    async function onLogout() {
        logout();
        await refresh();
        setOpen(false);
        nav("/manager");
    }

    return (
        <div className="account" ref={ref}>
            <button className="account-btn" onClick={()=>setOpen(v=>!v)} type="button" aria-label="Account">
                {/* simple user icon */}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                    <path d="M12 12a4.5 4.5 0 1 0-4.5-4.5A4.5 4.5 0 0 0 12 12Zm0 2c-4.2 0-8 2.1-8 5v1h16v-1c0-2.9-3.8-5-8-5Z"/>
                </svg>
            </button>

            {open && (
                <div className="account-dd">
                    {!user ? (
                        <>
                            <Link className="account-a" to="/login" onClick={()=>setOpen(false)}>Login</Link>
                            <Link className="account-a" to="/register" onClick={()=>setOpen(false)}>Registrieren</Link>
                        </>
                    ) : (
                        <>
                            <div className="account-meta">
                                <div className="account-email">{user.email}</div>
                                <div className="account-role">{user.role}</div>
                            </div>

                            {user.role === "admin" && (
                                <Link className="account-a" to="/admin/users" onClick={()=>setOpen(false)}>
                                    Admin: User
                                </Link>
                            )}

                            <button className="account-a account-a--btn" onClick={onLogout} type="button">
                                Logout
                            </button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}